import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ProjectContext } from '../../contexts'
import { ProjectRole } from '../../types'
import NavLink from '../../ui/NavLink'
import { checkProjectRole } from '../../utils'
import './SettingsNav.css'

interface SettingsNavItem {
    key: string
    to: string
    label: string
    end?: boolean
}

interface SettingsNavSection {
    key: string
    label: string
    minRole: ProjectRole
    items: SettingsNavItem[]
}

export const settingsSections: SettingsNavSection[] = [
    {
        key: 'project',
        label: 'project',
        minRole: 'admin',
        items: [
            { key: 'general', to: '', label: 'general', end: true },
            { key: 'team', to: 'team', label: 'team' },
            { key: 'tags', to: 'tags', label: 'tags' },
        ],
    },
    {
        key: 'messaging',
        label: 'messaging',
        minRole: 'developer',
        items: [
            { key: 'integrations', to: 'integrations', label: 'integrations' },
            { key: 'subscriptions', to: 'subscriptions', label: 'topics' },
            { key: 'resources', to: 'resources', label: 'resources' },
        ],
    },
    {
        key: 'developers',
        label: 'developers',
        minRole: 'developer',
        items: [
            { key: 'api-keys', to: 'api-keys', label: 'api_keys' },
            { key: 'data', to: 'data', label: 'data_schema' },
            { key: 'globals', to: 'globals', label: 'global_data' },
            {
                key: 'webhooks',
                to: 'webhooks',
                label: 'webhook_subscriptions',
            },
        ],
    },
    {
        key: 'account',
        label: 'account',
        minRole: 'admin',
        items: [
            { key: 'usage', to: 'usage', label: 'usage' },
        ],
    },
]

export default function SettingsNav() {
    const { t } = useTranslation()
    const [project] = useContext(ProjectContext)

    return (
        <nav className="settings-nav">
            {settingsSections.filter(({ minRole }) => checkProjectRole(minRole, project.role)).map(section => (
                <div className="settings-nav-section" key={section.key}>
                    <span className="settings-nav-header">{t(section.label)}</span>
                    {section.items.map(({ key, label, ...props }) => (
                        <NavLink key={key} {...props}>{t(label)}</NavLink>
                    ))}
                </div>
            ))}
        </nav>
    )
}
